import { useCallback, useEffect, useState } from 'react'
import { getFaqCapabilities } from '../../api/faq'

// What the FAQ page may show this user. `can_write` comes from here, not
// from RBAC: the role table only knows full / no access for bot config.
export default function useFaqCapabilities(tenantId) {
  const [attempt, setAttempt] = useState(0)
  const [settled, setSettled] = useState({ key: null, capabilities: null, error: null })
  const key = tenantId ? `${tenantId}:${attempt}` : null

  useEffect(() => {
    if (!key) return undefined
    let alive = true
    getFaqCapabilities(tenantId)
      .then((capabilities) => alive && setSettled({ key, capabilities, error: null }))
      .catch((error) => alive && setSettled({ key, capabilities: null, error }))
    return () => {
      alive = false
    }
  }, [tenantId, key])

  const refetch = useCallback(() => setAttempt((count) => count + 1), [])

  // An answer for another tenant is not this tenant's answer.
  const current = settled.key?.startsWith(`${tenantId}:`) ? settled : { capabilities: null, error: null }
  return {
    capabilities: current.capabilities,
    error: settled.key === key ? settled.error : null,
    loading: Boolean(key) && settled.key !== key,
    refetch,
  }
}
